var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4262 23C29.4262 22.7239 29.2024 22.5 28.9262 22.5C28.6501 22.5 28.4262 22.7239 28.4262 23H29.4262ZM2.64645 44.4843C2.45118 44.6796 2.45118 44.9962 2.64645 45.1914L5.82843 48.3734C6.02369 48.5687 6.34027 48.5687 6.53553 48.3734C6.7308 48.1782 6.7308 47.8616 6.53553 47.6663L3.70711 44.8379L6.53553 42.0095C6.7308 41.8142 6.7308 41.4976 6.53553 41.3024C6.34027 41.1071 6.02369 41.1071 5.82843 41.3024L2.64645 44.4843ZM28.4262 23C28.4262 29.7251 24.9262 35.0475 19.9783 38.7061C15.0225 42.3707 8.64565 44.3379 3 44.3379V45.3379C8.85435 45.3379 15.4406 43.3051 20.5729 39.5102C25.7131 35.7093 29.4262 30.1128 29.4262 23H28.4262Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave25);
export default __webpack_public_path__ + "static/media/save-25.642c5b927bea5cdc5398789414fe5c07.svg";
export { ForwardRef as ReactComponent };